import Joi from 'joi';

export const getProductDescriptionSchema = (isEuRequired = false, _isUsDestination = false) =>
  Joi.object().keys({
    id: Joi.string().optional(),
    description: Joi.string().required().messages({ 'string.empty': 'Please enter Description' }),
    quantity: Joi.number()
      .min(1)
      .required()
      .messages({ 'number.base': 'Please enter Quantity', 'number.min': 'Quantity should be greater than 0' }),
    unitValue: Joi.number().min(0.0001).required().messages({
      'number.base': 'Please enter unit value',
      'number.min': 'Unit value should be 0.0001 or above',
    }),
    HSNName: Joi.optional(),
    HSNCode: Joi.optional(),
    totalValue: Joi.optional(),
    actions: Joi.optional(),
    productName: Joi.optional(),
    value: Joi.optional(),
    productId: Joi.string().allow('', null).optional(),
    productIdType: Joi.string().allow('', null).optional(),
    merchantProductId: isEuRequired
      ? Joi.string().trim().required().messages({
          'string.empty': 'Please enter Merchant ID (M-PID)',
          'any.required': 'Please enter Merchant ID (M-PID)',
        })
      : Joi.string().allow('', null).optional(),
    standardManufacturerProductId: Joi.string().allow('', null).optional(),
    nonStandardManufacturerProductId: isEuRequired
      ? Joi.string().trim().required().messages({
          'string.empty': 'Please enter Manufacturer part no. (NS-PID)',
          'any.required': 'Please enter Manufacturer part no. (NS-PID)',
        })
      : Joi.string().allow('', null).optional(),
    cpscCompliance: Joi.object({
      beingSold: Joi.any().optional(),
      disclaimCode: Joi.string().optional().allow('', null),
      additionalContext: Joi.string().optional().allow('', null),
      certificateFiled: Joi.any().optional(),
      productIdRegistry: Joi.string().optional().allow('', null),
      certificateVersionId: Joi.string().optional().allow('', null),
      certifierId: Joi.string().optional().allow('', null),
      productId: Joi.string().optional().allow('', null),
      productIdType: Joi.string().optional().allow('', null),
    })
      .optional()
      .allow(null),
    compliance: Joi.optional().allow(null),
  });

export const productDescriptionSchema = getProductDescriptionSchema(false, false);
